<template>
  <div class="place pt-[60px]">
    <div class="img"></div>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";


export default defineComponent({
  name: "AdenCabin",
  components: {
  },
  data() {
    return {

    };
  },
})
</script>

<style lang="scss" scoped>

.img {
  background: url(~views/topic/202208/aden/imgs/cabin_bg.png) center no-repeat;
  background-size: auto 2213px;
  background-position: center;
  height: 2213px;
}

</style>
